import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ArrowRight, TrendingUp } from 'lucide-react';

const MyWork = () => {
  const featuredWork = [
    {
      id: 1,
      brand: "Amazon",
      title: "Small upgrades, big difference.",
      type: "UGC Ad Campaign",
      result: "1M+ views",
      description: "Created authentic product review videos showcasing Amazon products in real-life scenarios",
      image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&h=300&fit=crop&crop=center",
      metrics: "1M+ views • 4.2% engagement rate"
    },
    {
      id: 2, 
      brand: "Pinterest",
      title: "Lifestyle product and outfit showcase",
      type: "Aesthetic Videos",
      result: "Boosted brand presence",
      description: "Created visually appealing lifestyle content that perfectly aligned with Pinterest's aesthetic standards",
      image: "https://images.unsplash.com/photo-1611930022073-b7a4ba5fcccd?w=400&h=300&fit=crop&crop=center",
      metrics: "250K+ impressions • 6.8% save rate"
    },
    {
      id: 3,
      brand: "Jill Yoga",
      title: "Wellness content strategy",
      type: "Social Media Strategy",
      result: "5x Views Growth",
      description: "Dynamic content strategy with short-form trending videos and high-quality themed content production",
      image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=300&fit=crop&crop=center",
      metrics: "5x increase in views • Enhanced community engagement"
    },
    {
      id: 4,
      brand: "Squid Media",
      title: "Creative agency branding",
      type: "Brand Strategy",
      result: "Enhanced Brand Presence",
      description: "Comprehensive content strategy focusing on behind-the-scenes content and creative showcases",
      image: "https://customer-assets.emergentagent.com/job_identity-forge-17/artifacts/7r85qpm8_Screenshot%202025-10-09%20at%205.23.24%E2%80%AFPM.png",
      logo: "https://customer-assets.emergentagent.com/job_identity-forge-17/artifacts/err4v4fa_download%20%282%29.png",
      metrics: "Increased brand awareness • Enhanced client engagement"
    },
    {
      id: 5,
      brand: "WitsType.ai",
      title: "AI platform positioning",
      type: "Content Strategy",
      result: "Strong Brand Recognition",
      description: "Educational content strategy and AI insights to establish thought leadership in AI content space",
      image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=400&h=300&fit=crop&crop=center",
      logo: "https://customer-assets.emergentagent.com/job_identity-forge-17/artifacts/1ci17kdk_WitsType%20AI%20Logo%20%282%29%20%281%29.png",
      metrics: "Built brand recognition • Increased user acquisition"
    }
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          {/* Section Title */}
          <div className="text-sm font-medium text-pink-500 flex items-center justify-center gap-2 mb-4">
            📸 My Work
          </div>
          
          {/* Headline */}
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            From UGC to campaigns, here's the 
            <span className="relative">
              <span className="bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent"> proof</span>
              {/* Underline doodle */}
              <svg className="absolute -bottom-2 left-0 w-full h-3" viewBox="0 0 200 12" fill="none">
                <path 
                  d="M2 9c40-3 80-6 120-3 30 2 60 4 76 2" 
                  stroke="#ec4899" 
                  strokeWidth="2" 
                  strokeLinecap="round"
                  fill="none"
                  className="animate-pulse"
                />
              </svg>
            </span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            I've worked with global brands and local businesses alike  delivering content that not only looks good, but performs.
          </p>
        </div>

        {/* Featured Work Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {featuredWork.map((work) => (
            <Card key={work.id} className="group overflow-hidden border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="relative">
                <img 
                  src={work.image} 
                  alt={`${work.brand} campaign`}
                  className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                
                {/* Brand badge */}
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  {work.logo && (
                    <img 
                      src={work.logo} 
                      alt={`${work.brand} logo`}
                      className="w-8 h-8 object-contain"
                    />
                  )}
                  <span className="bg-white/90 backdrop-blur-sm text-gray-900 px-3 py-1 rounded-full text-sm font-semibold">
                    {work.brand}
                  </span>
                </div>
              </div>
              
              <CardContent className="p-6">
                <div className="space-y-3">
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">
                      "{work.title}"
                    </h3>
                    <p className="text-sm text-gray-600">
                      {work.type} → {work.result}
                    </p>
                  </div>
                  
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {work.description}
                  </p>
                  
                  <div className="flex items-center gap-2 pt-2">
                    <TrendingUp className="h-4 w-4 text-green-600" />
                    <span className="text-sm font-medium text-gray-700">
                      {work.metrics}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MyWork;